export const formattedObj = (data, dataCondition) => data && Object.keys(dataCondition).map((key) => {
    return {
        id: +key,
        value: dataCondition[key],
    };
});